/**
 增值服务
 */
import React, { Component } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XSelect, XOKButton, XCancelButton, XDatePicker } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import commonModel from '@/reducers/operation/common/model';
import model from '@/reducers/operation/city/model';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class City extends Component {

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        match: PropTypes.object,
        getCompanyCitys: PropTypes.func,
        companyCitys: PropTypes.object,
        getCompanySele: PropTypes.func,
        companySele: PropTypes.object,
        getProvinces: PropTypes.func,
        provinces: PropTypes.array,
        getCitys: PropTypes.func,
        citys: PropTypes.array,
        setBreadcrumbPaths: PropTypes.func,
    }

    static defaultProps = {
        companyCitys: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 },
        companySele: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 },
        provinces: [],
        citys: []
    }

    state = {
        modal: false,
        modalParam: {},
        companyItem: {},
        startTime: null,
        endTime: null,
        provinceItem: {},
        cityItem: {},
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match, getCompanySele, getProvinces, getCitys } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        getCompanySele({ pageNum: 1, pageSize: 100000 });
        getProvinces({ id: 0 });
        getCitys({ id: '1' });
    }

    _searchHandle = (useCache) => {
        const { pageNum, pageSize, companyItem, startTime, endTime, provinceItem, cityItem } = this.state;
        let query = {};
        query = {
            status: 'PASS',
            startTime: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
            endTime: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
            cityId: cityItem.id,
            provinceId: provinceItem.id,
            companyId: companyItem.companyId,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getCompanyCitys(query);
        KeepAlive.saveCache({ ...query, cityItem, provinceItem, companyItem }); // 【第3步，缓存查询状态】
    }

    _resetHandle = () => {
        this.setState({
            companyItem: {},
            startTime: null,
            endTime: null,
            provinceItem: {},
            cityItem: {}
        }, () => {
            this.props.getCitys({ id: '1' });
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    ///请求
    _request = (url, data, tip) => {
        http(url, data, 'POST')
            .then(() => {
                this._searchHandle('useCache');
                message.success(tip);
            })
            .catch(err => message.error(err.message));
    }

    render() {
        const { companyItem, startTime, endTime, provinceItem, cityItem } = this.state;
        const { companySele, companyCitys, getCitys, provinces, citys } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 调用查询接口初始化数据
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XSelect
                                label='运营公司'
                                placeholder='请选择运营公司'
                                renderData={companySele.dataList}
                                dataIndex='companyName'
                                keyIndex='companyId'
                                value={companyItem.companyName}
                                bindThis={this}
                                bindName='companyItem'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='上线日期'
                                placeholder='请选择开始时间'
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                showTime={false}
                                disabledDate={current => {
                                    if (current && endTime && current > endTime) {
                                        return true;
                                    }
                                }}
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                placeholder='请选择结束时间'
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                disabledDate={current => {
                                    if (current && startTime && current < startTime) {
                                        return true;
                                    }
                                }}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='省份'
                                placeholder='请选择省份'
                                renderData={provinces}
                                dataIndex='areaName'
                                keyIndex='id'
                                value={provinceItem.areaName}
                                bindThis={this}
                                bindName='provinceItem'
                                showSearch={true}
                                onChange={e => {
                                    this.setState({ cityItem: {} });
                                    getCitys({ id: e.id });
                                }}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='城市'
                                placeholder='请选择城市'
                                renderData={citys}
                                dataIndex='areaName'
                                keyIndex='id'
                                value={cityItem.areaName}
                                bindThis={this}
                                bindName='cityItem'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    {/* <XOKButton
                        style={{ width: '90px' }}
                        label='生成报表'
                        onClick={this._searchHandle}
                    /> */}
                    <TableContent
                        renderData={companyCitys}
                        paginationChange={this._paginationChange}
                        request={this._request} />
                </div>
            </KeepAlive>
        );
    }
}
export default connect((state) => ({
    companyCitys: state.operationCity.companyCitys,
    companySele: state.operationCity.companySele,
    provinces: state.operationCommon.provinces,
    citys: state.operationCommon.citys,
}), {
    ...commonModel.actions,
    ...model.actions,
    setBreadcrumbPaths
})(City);